import { render, staticRenderFns } from "./LogoAboutImagesSection.vue?vue&type=template&id=f8a0628a"
import script from "./LogoAboutImagesSection.vue?vue&type=script&lang=ts"
export * from "./LogoAboutImagesSection.vue?vue&type=script&lang=ts"
import style0 from "./LogoAboutImagesSection.vue?vue&type=style&index=0&id=f8a0628a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports